import styled from 'styled-components';

const Container = styled.div`
  min-height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 4rem;

  @media (max-width: 1080px) {
    padding: 0 2rem;
  }
`;

const Main = styled.main`
  max-width: var(--content-max);
  width: 100%;
  align-self: center;
  margin: 3rem 0 0;
  flex: 1;
`;

export { Container, Main };
